module.exports = __webpack_public_path__ + "img/right-leg.3ef2318a.png";